import { graphql } from '~/lib/graphql'

export const PlanReserveInfo = graphql(`
  fragment PlanReserveInfo on ReserveInfo {
    visitDate
    visitTime
    visitorsCount
    discountCouponValidationHash
    duplicateReserveCount
    toyotaFinanceMaintenance
    gmoMaintenance
    paypayMaintenanceMessage
    paypayNoticeMessage
    ...ReserveInfoMember
    ...ReserveInfoPlan
    ...ReserveInfoChildMenus
    ...ReserveInfoOptionMenus
    point {
      seatOnlyFixedPoint
      courseFixedPoint
      rate
    }
    affiliateSiteForm {
      title
      notes
    }
    inventory {
      visitTime
      price
      discountRatePercent
      ...InventorySeats
    }
  }
`)
